// extracted by css-extract-rspack-plugin
export default {"TilaErrorMessage":"sputnik__TilaErrorMessage__GzCu1","tilaErrorMessage":"sputnik__TilaErrorMessage__GzCu1"};